import { JobRanking as JobRankingType } from '@doda/common/src/types/jobSearchList/jobContent';
import { RankingSummary } from '@doda/pc/src/pages/DodaFront/View/JobSearchList/components/JobRanking/RankingSummary';
import { RankingContainer } from '@doda/pc/src/pages/DodaFront/View/JobSearchList/components/JobRanking/RankingContainer';
import styles from './index.module.scss';

/**
 * JobRankingのprops
 * @property jobRankings 1ページで表示する複数軸の求人ランキング
 */
interface JobRankingProps {
  jobRankings: JobRankingType[];
}

/**
 * ジョブランキング
 * 求人ランキングサマリとランキングコンテナを出力するコンポーネント
 */
export const JobRanking = ({ jobRankings }: JobRankingProps) => {
  if (jobRankings.length === 0) {
    return null;
  }

  // 単一軸の場合のみ軸のラベルを表示
  const label =
    jobRankings.length === 1 ? jobRankings[0].searchAxis.label : undefined;

  return (
    <div className={styles.jobRanking}>
      <RankingSummary label={label} updatedDate={jobRankings[0].updatedDate} />
      <RankingContainer jobRankings={jobRankings} />
    </div>
  );
};
